package org.gstechnovos.jexonplastech.sections.products.sections

import androidx.compose.runtime.Composable
import org.gstechnovos.jexonplastech.components.widgets.GlobalCtaData
import org.gstechnovos.jexonplastech.components.widgets.GlobalCtaWidget

// ==========================================
// CMS DATA MODEL
// ==========================================
/**
 *
 * Text Constraints:
 * Headline: Limit to 4–7 words (e.g., "Need a Custom Manufacturing Run?").
 *
 * Description: Limit to 1–2 sentences (approx. 15-20 words) so it supports the headline
 * without cluttering the view.
 *
 * Button Text: Limit to 2–4 words (e.g., "Request Custom Order").
 *
 */
val defaultProductsCtaData = GlobalCtaData(
    headline = "Need a Custom Manufacturing Run?",
    description = "If you don't see the exact specifications you need, contact us. We offer custom molding and branding for high-volume B2B orders.",
    buttonText = "Request Custom Order",
    buttonPath = "/contact"
)

// ==========================================
// COMPONENT
// ==========================================

@Composable
fun ProductsCtaSection(data: GlobalCtaData = defaultProductsCtaData) {
    // Renders the global widget using the products-specific data
    GlobalCtaWidget(data = data)
}